import {
  CREATE_COURSE,
  GET_COURSE,
  GET_COURSES,
  SET_ALL_COURSES,
  UPDATE_COURSE,
  SET_ALL_COURSES_SELECT,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_COURSES:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_COURSES:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_COURSES_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.title}`,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    case CREATE_COURSE:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_COURSE:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_COURSE:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default courseReducer;
